import styled from "styled-components";
import theme from "../theme";

export const SummaryListActions = styled.dt`
  margin-bottom: 15px;

  @media (min-width: 40.0625em) {
    width: 20%;
    padding-right: 0;
    text-align: right;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid ${theme.colors.midGrey};
    display: table-cell;
    padding-right: 20px;
  }
`;
